/** 统一按数值计算成人和儿童总用餐人数，兼容订单同步传入的字符串。 */
export function getRequiredDiningPersonCount (person?: number | string, kids?: number | string) {
  return (Number(person) || 0) + (Number(kids) || 0)
}

export function getRequiredProductQuantity (requiredQuantity?: number | string, requiredQuantityType?: TRequiredQuantityType | string, person?: number | string, kids?: number | string) {
  const quantity = Number(requiredQuantity) || 0
  return isRequiredPerPerson(requiredQuantityType)
    ? quantity * getRequiredDiningPersonCount(person, kids)
    : quantity
}

export function isRequiredPerPerson (requiredQuantityType?: TRequiredQuantityType | string) {
  return String(requiredQuantityType || '').trim().toUpperCase() === 'PER_PERSON'
}

/** 返回购物车中超过最低必选数量的份数。 */
export function getRequiredProductExcessQuantity (actualQuantity?: number | string, requiredQuantity?: number | string) {
  return Math.max(0, (Number(actualQuantity) || 0) - (Number(requiredQuantity) || 0))
}

/** 只有购物车已有餐品时，才允许触发必选餐品的自动同步。 */
export function canAutoSyncRequiredProducts (cartItemCount?: number) {
  return (Number(cartItemCount) || 0) > 0
}

/** 必选规则只统计直接点入的普通餐品，排除套餐、换购和满赠子项。 */
export function isDirectCartProduct (item: { type?: string; productGroups?: unknown[]; isOrderSwapBuy?: boolean | 0 | 1; ordersHuangou?: boolean | 0 | 1; isFullItemNFree?: boolean | 0 | 1; parentId?: string | number }, childNode = false) {
  const isOrderChild = typeof item.parentId !== 'undefined' && item.parentId !== '0' && item.parentId !== 0
  return !childNode && !isOrderChild && item.type === 'product' && !item.productGroups?.length && !item.isOrderSwapBuy && !item.ordersHuangou && !item.isFullItemNFree
}

/** 订单明细的 cnt 已是退菜后的剩余数量，可直接用于满足必选规则。 */
export function getRequiredProductAvailableQuantity (cnt?: number | string) {
  return Math.max(0, Number(cnt) || 0)
}

/** 后付费加菜时，购物车只需补足已下单餐品之外的必选缺口。 */
export function getRequiredCartProductQuantity (requiredQuantity?: number | string, orderQuantity?: number | string) {
  return Math.max(0, (Number(requiredQuantity) || 0) - (Number(orderQuantity) || 0))
}

/** 仅在用餐总人数减少时，才允许移除超过最低必选数量的餐品。 */
export function shouldRemoveRequiredProductExcess (previousDiningPersonCount?: number, nextDiningPersonCount?: number) {
  return (Number(nextDiningPersonCount) || 0) < (Number(previousDiningPersonCount) || 0)
}

/** 仅当餐品的规格、加料及其他点餐属性完全一致时，才可安全地自动移除。 */
export function canAutoRemoveRequiredProductExcess (items: Array<{ fkey: string; cnt: number | string }>, actualQuantity?: number | string) {
  const cartQuantity = items.reduce((quantity, item) => quantity + (Number(item.cnt) || 0), 0)
  return items.length > 0 && cartQuantity === (Number(actualQuantity) || 0) && new Set(items.map(item => item.fkey)).size === 1
}

/** 将餐品和分组缺口统一转换为展示文案所需的数据。 */
export function getRequiredSelectionMessageParts (shortages: IRequiredSelectionShortage[], formatItem = (item: IRequiredSelectionShortage) => `${item.name} 还差${item.requiredQuantity - item.actualQuantity}份`) {
  return {
    products: shortages
      .filter(item => item.kind === 'product')
      .map(formatItem)
      .join(', '),
    categories: shortages
      .filter(item => item.kind === 'category')
      .map(formatItem)
      .join(', ')
  }
}
